import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";

import { Button } from "~/components/ui/button";
import type { BrandMatch } from "~/routes/root";

import { AnimatedCheck } from "../animated-check/animated-check";

export const UpdatingInfoThankYou: React.FC = () => {
  const navigate = useNavigate();
  const { brandId = "" } = useParams<BrandMatch>();
  const { t } = useTranslation();

  return (
    <div className="flex h-screen flex-col items-center justify-center gap-10">
      <div className="flex flex-col items-center gap-6">
        <AnimatedCheck className="size-24" />
        <div className="flex flex-col gap-2">
          <div className="text-center text-[32px] font-bold leading-[40px] text-gray-900">
            {t("onboarding.thank_you.ready_to_start")}
          </div>
          <p className="text-sm text-gray-700">
            {t("onboarding.thank_you.info_saved")}
          </p>
        </div>
      </div>
      <Button
        type="button"
        size="lg"
        onClick={() => {
          navigate(`/${brandId}/home`);
        }}
      >
        {t("onboarding.thank_you.access_dashboard")}
      </Button>
    </div>
  );
};
